export default function Footer() {
    return (
        <footer className="footer" style={{height: 100}}>
            
        </footer>
    );
}